<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Task Periodici </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Bottone di aggiunta -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="modificaTask(null)" v-bind="attrs" v-on="on" small>
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Nuovo Task Periodico</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di indietro -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="goBack" v-bind="attrs" v-on="on" small>
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-data-table :headers="header_tasks" :items="items_task_periodici">
              <!-- Bottone di modifica -->
              <template v-slot:[`item.modifica`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="modificaTask(item)"
                      v-bind="attrs"
                      v-on="on"
                      small
                    >
                      <v-icon color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Modifica</span>
                </v-tooltip>
              </template>

              <!-- Colonna del progetto -->
              <template v-slot:[`item.id_progetto`]="{ item }">
                {{
                  items_progetti.filter(
                    (elem) => elem.id_progetto === item.id_progetto
                  )[0]?.des_progetto
                }}
              </template>

              <!-- Colonna del responsabile -->
              <template v-slot:[`item.id_utente_task`]="{ item }">
                {{
                  items_risorse.filter(
                    (elem) => elem.id_personale === item.id_utente_task
                  )[0]?.nominativo
                }}
              </template>

              <!-- Colonna della cadenza -->
              <template v-slot:[`item.cadenza`]="{ item }">
                {{ getStringaCadenza(item) }}
              </template>

              <!-- Bottone di eliminazione -->
              <template v-slot:[`item.elimina`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="clickEliminaTaskPeriodico(item)"
                      v-bind="attrs"
                      v-on="on"
                      small
                    >
                      <v-icon color="error"> mdi-delete </v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-dialog v-model="dialog_dettaglio_task" width="85vw" persistent>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Task
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaTask" v-bind="attrs" v-on="on" small>
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="chiudiModificaTask" v-bind="attrs" v-on="on" small>
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="3">
                <v-autocomplete
                  label="Progetto"
                  :items="items_progetti"
                  item-text="des_progetto"
                  item-value="id_progetto"
                  v-model="task_tmp.id_progetto"
                  @change="
                    task_tmp.id_area_progetti_task = null;
                    getAreeProgetto();
                  "
                />
              </v-col>
              <v-col cols="3" padding="4px">
                <v-autocomplete
                  label="Area Progetto"
                  :items="items_aree_progetti"
                  item-text="des"
                  item-value="id_progetto_area_computo"
                  v-model="task_tmp.id_area_progetti_task"
                  :key="key_aree_progetti"
                />
              </v-col>
              <v-col cols="3">
                <v-select
                  label="Priorità"
                  :items="items_lista_priorita"
                  v-model="task_tmp.livello"
                />
              </v-col>
              <v-col cols="3">
                <v-autocomplete
                  label="Responsabile"
                  :items="items_risorse"
                  item-text="nominativo"
                  item-value="id_personale"
                  v-model="task_tmp.id_utente_task"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="task_tmp.id_utente_task = null"
                      icon
                      v-show="task_tmp.id_utente_task != null"
                      color="error"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-text-field dense label="Titolo" v-model="task_tmp.titolo" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-textarea
                  dense
                  label="Descrizione"
                  outlined
                  style="border-radius: 0px"
                  v-model="task_tmp.note"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="2">
                <v-text-field
                  dense
                  label="Qta Intervallo"
                  type="number"
                  v-model="task_tmp.qta_intervallo"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="task_tmp.qta_intervallo = null"
                      icon
                      v-show="task_tmp.qta_intervallo != null"
                      color="error"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-autocomplete
                  dense
                  :items="
                    task_tmp.qta_intervallo == null
                      ? items_um_intervallo.filter(
                          (elem) => elem.val_int == 1 || elem.val_int == 2
                        )
                      : items_um_intervallo.filter((elem) => elem.val_int == 0)
                  "
                  item-text="des"
                  item-value="id_tabella"
                  label="UM intervallo"
                  v-model="task_tmp.um_intervallo"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  dense
                  label="Data inizio"
                  type="datetime-local"
                  v-model="task_tmp.data_inizio"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  dense
                  label="Data fine"
                  type="datetime-local"
                  @keydown="show_data_fine = true"
                  v-model="task_tmp.data_fine"
                  :key="key_data_fine"
                >
                  <template v-slot:append>
                    <v-icon
                      @click="
                        task_tmp.data_fine = null;
                        show_data_fine = false;
                        key_data_fine = !key_data_fine;
                      "
                      icon
                      v-show="task_tmp.data_fine != null || show_data_fine"
                      color="error"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Overlay di caricamento interno -->
      <v-overlay :value="overlay" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di conferma eliminazione -->
    <v-dialog v-model="dialog_conferma_eliminazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare il task periodico selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_eliminazione = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn
                  @click="
                    dialog_conferma_eliminazione = false;
                    salvaTask();
                  "
                  small
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento esterno -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class TaskPeriodico {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "data_inizio", complex: false, default_val: null },
      { nome: "data_fine", complex: false, default_val: null },
      { nome: "id_area_progetti_task", complex: false, default_val: null },
      { nome: "id_azienda_quickview", complex: false, default_val: null },
      { nome: "id_progetto", complex: false, default_val: null },
      { nome: "id_task_periodico", complex: false, default_val: -1 },
      { nome: "id_utente_creazione", complex: false, default_val: null },
      { nome: "id_utente_task", complex: false, default_val: null },
      { nome: "livello", complex: false, default_val: 3 },
      { nome: "note", complex: false, default_val: null },
      { nome: "qta_intervallo", complex: false, default_val: null },
      { nome: "titolo", complex: false, default_val: null },
      { nome: "um_intervallo", complex: false, default_val: null },
      { nome: "validita", complex: false, default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "",
  components: { SnackbarQV },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      key_aree_progetti: 0,
      key_data_fine: true,
      request_counter: 0,
      show_data_fine: false,
      task_tmp: new TaskPeriodico(),

      // Modal
      dialog_conferma_eliminazione: false,
      dialog_dettaglio_task: false,
      overlay: false,

      // Array
      header_tasks: [
        {
          text: "Modifica",
          value: "modifica",
          width: "100px",
          sortable: false,
        },
        {
          text: "Titolo",
          value: "titolo",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "note",
          sortable: false,
        },
        {
          text: "Progetto",
          value: "id_progetto",
          sortable: false,
        },
        {
          text: "Area",
          value: "des_area",
          sortable: false,
        },
        {
          text: "Responsabile",
          value: "id_utente_task",
          sortable: false,
        },
        {
          text: "Cadenza",
          value: "cadenza",
          sortable: false,
        },
        {
          text: "Elimina",
          value: "elimina",
          sortable: false,
          width: "100px",
        },
      ],
      items_aree_progetti: new Array(),
      items_lista_priorita: [
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
      ],
      items_progetti: new Array(),
      items_risorse: new Array(),
      items_task_periodici: new Array(),
      items_um_intervallo: new Array(),
    };
  },
  computed: {},
  watch: {
    request_counter: {
      immediate: true,
      handler() {
        if (this.request_counter <= 0) {
          this.overlay = false;
        } else {
          if (!this.overlay) this.overlay = true;
        }
      },
    },
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    chiudiModificaTask() {
      this.dialog_dettaglio_task = false;
    },
    clickEliminaTaskPeriodico(arg) {
      this.task_tmp = new TaskPeriodico(arg);
      this.task_tmp.validita = 0;
      this.dialog_conferma_eliminazione = true;
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " alle ";
          strRes += arg_data.substr(11, 5);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    getAreeProgetto() {
      this.items_aree_progetti = [];
      if (!this.task_tmp.id_progetto) return;

      let request = {
        controller: "contabilita",
        method: "POST",
        richiesta: {
          action: "getprogettiareecomputo",
          token: localStorage.user_token,
          id_progetto: this.task_tmp.id_progetto,
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.request_counter--;
          if (res.status == 200) {
            this.items_aree_progetti = res.data.result.t_progetti_aree_computo;
            this.key_aree_progetti = this.key_aree_progetti === 0 ? 1 : 0;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati dei progetti."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati dei progetti."
          );
        });
    },
    getProgetti() {
      let request = null;
      request = {
        controller: "contabilita",
        method: "POST",
        richiesta: {
          action: "getprogetti",
          token: localStorage.user_token,
          filtri: [],
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.request_counter--;
          if (res.data.statusCode === 200) {
            this.items_progetti = res.data.result.progetti;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati dei progetti."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati dei progetti."
          );
        });
    },
    getRisorse() {
      var request = {
        controller: "Utente",
        method: "POST",
        richiesta: {
          action: "getutentelist",
          token: localStorage.user_token,
          id_utente: localStorage.id,
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            // Prendo gli utenti, che saranno le mie colonne.
            this.items_risorse = res.data.result[
              Object.keys(res.data.result)[0]
            ].filter(
              (e) =>
                e.id_azienda == localStorage.id_azienda &&
                e.validita == 1 &&
                e.attivo == 1
            );

            for (var r of this.items_risorse) {
              r.nominativo = r.nome + " " + r.cognome;
            }

            // Aggiungo una colonna per le attività non assegnate.
            const obj_non_assegnato = {
              id_utente: null,
              id_personale: null,
              id_profilo_utente: null,
              id_azienda: localStorage.id_azienda,
              nome: "Non",
              cognome: "assegnato",
              nominativo: "(Non assegnato)",
              validita: 1,
              tasks: [],
            };

            this.items_risorse.unshift(obj_non_assegnato);

            // Associo un title e un value per comodità di kanban.
            this.items_risorse.forEach((e, i) => {
              e.title = `${e.nome} ${e.cognome}`;
              e.tasks = [];
              e.value = `col${i}`;
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati dei progetti."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati dei progetti."
          );
        });
    },
    getStringaCadenza(arg) {
      let res = "";

      if (arg.qta_intervallo != null) {
        // Se ho una cadenza fissa la compongo instringa.
        res += `Ogni ${arg.qta_intervallo}
                ${
                  this.items_um_intervallo.filter(
                    (elem) => elem.id_tabella == arg.um_intervallo
                  )[0]?.des
                }
                a partire dal ${this.formatData(arg.data_inizio, "full")}`;
      } else {
        // Se non ho una cadenza fissa compongo in stringa il criterio.
        res += `${
          this.items_um_intervallo.filter(
            (elem) => elem.id_tabella == arg.um_intervallo
          )[0]?.des
        }
                a partire dal ${this.formatData(arg.data_inizio, "full")}`;
      }

      // Aggiungo la data fine se serve
      if (arg.data_fine != null)
        res += ` fino al ${this.formatData(arg.data_fine, "full")}`;

      return res;
    },
    getTabella() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "PROGETTO_TASK_PERIODICO",
          filter: "validita = 1",
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.request_counter--;
            this.items_um_intervallo = res.data != undefined ? res.data : [];
            // Ordino per id_tabella
            this.items_um_intervallo.sort((a, b) => a.ordine - b.ordine);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nel caricamento delle UM intervallo."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nel caricamento delle UM intervallo."
          );
        });
    },
    getTaskPeriodici() {
      const request = {
        controller: "ticket",
        method: "POST",
        richiesta: {
          action: "gettaskperiodici",
          token: localStorage.user_token,
        },
      };

      this.request_counter++;
      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.items_task_periodici = res.data.result.tasks;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    goBack() {
      this.$router.push("/home/notice");
    },
    modificaTask(arg) {
      if (arg == null) {
        this.task_tmp = new TaskPeriodico({
          data_inizio: moment().format("YYYY-MM-DDT00:00"),
          id_utente_creazione: localStorage.id,
          id_azienda_quickview: localStorage.id_azienda,
        });
      } else {
        this.task_tmp = new TaskPeriodico(arg);
        this.getAreeProgetto();
      }
      this.dialog_dettaglio_task = true;
    },
    salvaTask() {
      // Verifico che ci sia una data inizio.
      if (
        this.task_tmp.data_inizio == null ||
        this.task_tmp.data_inizio === ""
      ) {
        this.$refs.SnackbarQV.print("orange", "Valorizzare la data inizio.");
        return;
      }

      // Verifico che ci sia la UM intervallo.
      if (
        this.task_tmp.um_intervallo == null ||
        this.task_tmp.um_intervallo === ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare l'unità di misura dell'intervallo."
        );
        return;
      }

      /* Verifico che ci sia la quantità intervallo:
       * se la quantità è nulla e sono a cadenza fissa... */
      if (
        (this.task_tmp.qta_intervallo == null ||
          this.task_tmp.qta_intervallo === "") &&
        this.items_um_intervallo.filter(
          (elem) => elem.id_tabella === this.task_tmp.um_intervallo
        )[0]?.val_int === 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare la quantità intervallo."
        );
        return;
      }

      /* Verifico che la quantità intervallo sia maggiore di 0:
       * se la quantità è inferiore a 0 e sono a cadenza fissa... */
      if (
        this.task_tmp.qta_intervallo <= 0 &&
        this.items_um_intervallo.filter(
          (elem) => elem.id_tabella === this.task_tmp.um_intervallo
        )[0]?.val_int === 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La quantità intervallo deve essere maggiore di 0."
        );
        return;
      }

      // Verifico che ci sia il titolo.
      if (this.task_tmp.titolo == null || this.task_tmp.titolo === "") {
        this.$refs.SnackbarQV.print("orange", "Indicare il titolo.");
        return;
      }

      const request = {
        controller: "ticket",
        method: "PUT",
        richiesta: {
          action: "settaskperiodico",
          token: localStorage.user_token,
          tasks: [this.task_tmp],
        },
      };

      this.dialog_dettaglio_task = false;
      this.request_counter++;
      this.$store
        .dispatch("api6", request)
        .then((res) => {
          this.request_counter--;
          if (res.status === 200) {
            this.getTaskPeriodici();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.request_counter--;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {
    this.getTabella();
    this.getTaskPeriodici();
    this.getProgetti();
    this.getRisorse();
  },
};
</script>
<style scoped>
</style>